import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setTypesDialog,
  resetForm,
  ExpenseTypes,
} from "../../../../app/slices/expenseTypesSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineDocumentText, HiOutlineTag } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const ExpenseTpesForm = () => {
  const _ExpenseTypes = useSelector((state) => state.expenseTypes.expenseTypes);
  const _SearchBody = useSelector((state) => state.expenseTypes.searchBody);

  const isAdd = _ExpenseTypes.form.id ? false : true;
  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _ExpenseTypes.form,
  });


  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(ExpenseTypes.create(data));
    } else {
      dispatch(ExpenseTypes.update(data.id, data, _SearchBody));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setTypesDialog());
  };

  return (
    <FormDialog
      open={_ExpenseTypes.dialog}
      onClose={handlDialog}
      icon={<HiOutlineTag />}
      title={isAdd ? "إضافة نوع مصروف" : "تعديل نوع المصروف"}
      subtitle={
        isAdd
          ? "أدخل اسم نوع المصروف لإضافته"
          : "قم بتحديث نوع المصروف ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={_ExpenseTypes.loading}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات النوع">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ExpenseTpesForm;
